import React, {memo, ReactNode, useCallback} from 'react';
import cx from 'classnames';
import {ColumnType} from '../types';
import {CellStyles} from '../types/CellStyles';
import styles from '../styles/Table.module.scss';

type Props = {
    columnStyles?: CellStyles;
    column: ColumnType;
    isActive: boolean;
    rowIndex: number;
    componentClasses?: string;
    onClick?: (id: number, rowIndex: number) => void;
    rowData: any;
    cellRenderer: <T>(params: {
        rowData: T | null;
        column: ColumnType;
        isActiveCell: boolean;
        rowIndex: number;
    }) => ReactNode;
};

export const TableCell = memo(
    ({
        cellRenderer,
        columnStyles,
        isActive,
        onClick,
        column,
        rowIndex,
        rowData,
        componentClasses
    }: Props) => {
        const {index, Name} = column;

        const onCellClick = useCallback(() => {
            onClick(index, rowIndex);
        }, [onClick, index, rowIndex]);

        return (
            <div
                data-rowidx={rowIndex}
                onClick={onCellClick}
                data-name={Name}
                style={columnStyles}
                className={cx(styles.tableCell, {
                    'table-active-cell': isActive,
                    [componentClasses]: componentClasses
                })}
            >
                {cellRenderer({
                    rowIndex,
                    column,
                    rowData,
                    isActiveCell: isActive
                })}
            </div>
        );
    }
);
